module.exports = __webpack_public_path__ + "831dc342f85dbe025665a9b34ac3acb2.svg";